<template>
  <div class="quiz-navigation">
    <div class="pagination-buttons">
      <button
        v-for="page in totalItems"
        :key="page"
        class="pagination-button"
        :class="getButtonClass(page)"
        @click="handlePageChange(page)"
      >
        {{ page }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuizNavigation",
  props: {
    currentIndex: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    results: {
      type: Array,
      default: () => [],
    },
    canNavigateToPast: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getButtonClass(page) {
      const classes = ["round-button"];

      // Current page
      if (page === this.currentIndex + 1) {
        classes.push("is-selected");
      } else if (!this.canNavigateToPast) {
        classes.push("is-disabled");
      }

      // Past pages with results
      const result = this.results[page - 1];
      if (result && result.status) {
        if (result.status === "correct") {
          classes.push("is-success");
        } else if (result.status === "incorrect") {
          classes.push("is-danger");
        } else if (result.status === "skipped") {
          classes.push("is-warning");
        } else {
          classes.push("is-light");
        }
      }

      return classes;
    },

    handlePageChange(page) {
      // Only allow navigation to past puzzles if enabled
      if (!this.canNavigateToPast && page > this.currentIndex + 1) {
        return;
      }

      this.$emit("navigate", page - 1);
    },
  },
};
</script>

<style scoped>
.quiz-navigation {
  margin: 1rem 0;
}

.pagination-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}

.pagination-button {
  border-radius: 50%;
  min-width: 2.5rem;
  height: 2.5rem;
  margin: 0 0.25rem;
  border: 2px solid #dbdbdb;
  background-color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.pagination-button.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-button.is-selected {
  border-color: #3273dc;
}

.pagination-button.is-success {
  background-color: #48c774;
  color: white;
}

.pagination-button.is-danger {
  background-color: #f14668;
  color: white;
}

.pagination-button.is-warning {
  background-color: #ffdd57;
  color: rgba(0, 0, 0, 0.7);
}
</style>
